export default __webpack_public_path__ + "static/media/logo.142ecf3c.png";